// extracted by mini-css-extract-plugin
export default {"wrapper":"PVPowerForecast_wrapper__2tD0O","elec_forecast":"PVPowerForecast_elec_forecast__N+8HV","income_forecast":"PVPowerForecast_income_forecast__PexDo"};